import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import { SERVICE_MOBILE } from '../constants'
import globals from '../globals'
import BuyMobileAddOns from '../components/BuyMobileAddOns'
import CustomLink from '../components/CustomLink'

const options = {
    postUrl: '/api/postBuyMobileAddOn',
    success: 'Success! Your addon(s) have been ordered and will be added to your account within the next few minutes.'
}
const state = {
    serviceId: null,
    selectedAddOns: [],
    termsAndConditions: false
}

const MobileAddOnsForm = (props) => {
    useEffect(() => {
        props.setDynamicValues({
            serviceId: props.serviceId
        })
    }, [props.serviceId])

    const handleToggleAddOn = id => {
        let ids
        if (props.values.selectedAddOns.includes(id)) {
            ids = [...props.values.selectedAddOns]
            ids.splice(props.values.selectedAddOns.indexOf(id), 1)
        } else {
            ids = [...props.values.selectedAddOns, id]
        }

        props.setDynamicValues({
            selectedAddOns: ids
        })
    }

    return (
        <div className='recharge-mobile-form'>
            <div className='row'>
                <div className='col-12 col-lg-12 px-2 px-lg-4 mb-4'>
                    <div className='text-center'>
                        <h2 className='m-0 mb-4' dangerouslySetInnerHTML={{ __html: globals.noWidows('Purchase your Add-on below. It will activate immediately') }} />
                    </div>
                    <BuyMobileAddOns
                        addOns={props.addOns}
                        handleToggle={handleToggleAddOn}
                        selectedAddOns={props.values.selectedAddOns}
                    />
                </div>
            </div>
            <div className='row my-2'>
                <div className='col-12 col-md-8 offset-md-2'>
                    <TermsAndConditionsCheckbox
                        errors={props.errors}
                        value={props.values.termsAndConditions}
                        handleClick={value => props.setDynamicValues({ termsAndConditions: value })}
                        type={SERVICE_MOBILE}
                    />
                    <br />
                </div>
            </div>
            <div className='row'>
                <div className='col-12 col-md-8 offset-md-2'>
                    {props.children}
                </div>
            </div>
            <div className='row mt-1'>
                <div className='col-12 col-md-4 offset-md-2 text-center text-md-left my-2'>
                    <Button title={props.values.selectedAddOns.length > 1 ? 'Buy Add-ons' : 'Buy Add-on'} action={props.handleSubmit} />
                </div>
                <div className='col-12 col-md-4 my-2 d-flex justify-content-center justify-content-md-end align-items-center'>
                    <CustomLink to='https://www.exetel.com.au/mobilephone/international-rates' className='color-grey underline'>International call rates</CustomLink>
                </div>
            </div>
        </div>
    )
}

MobileAddOnsForm.propTypes = {
    serviceId: PropTypes.number.isRequired,
    addOns: PropTypes.array.isRequired
}

export default FormHOC(MobileAddOnsForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/MobileAddOnsForm.js